import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.025 4.985c-1.7 0-3 1.271-3 2.933s1.3 2.933 3 2.933 3-1.27 3-2.933-1.3-2.933-3-2.933m0 3.91c-.6 0-1-.39-1-.977 0-.586.4-.977 1-.977s1 .39 1 .977-.4.978-1 .978m7.8-8.602a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.37 8.65 8.65 0 0 1 0 12.414.93.93 0 0 0 0 1.37c.2.194.5.292.7.292s.5-.098.7-.293c4.3-4.106 4.3-10.95 0-15.153m-14.2 1.37a.93.93 0 0 0 0-1.37.98.98 0 0 0-1.4 0 10.627 10.627 0 0 0 0 15.25c.2.196.5.294.7.294s.5-.098.7-.294a.93.93 0 0 0 0-1.368c-3.5-3.422-3.5-9.092 0-12.513m1.4 6.255c0-1.27.5-2.542 1.5-3.42.4-.392.3-.979 0-1.37a.98.98 0 0 0-1.4 0c-2.7 2.64-2.7 7.04 0 9.678.2.196.5.293.7.293s.5-.097.7-.293a.93.93 0 0 0 0-1.369c-1-.977-1.5-2.248-1.5-3.519m9.9-4.79a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.37c2 1.856 2 4.984.1 6.842l-.3.293c-.2.49 0 1.075.4 1.27.1.1.3.1.4.1.3 0 .5-.099.7-.295 2.9-2.64 2.9-6.94.1-9.58"
    }, null, -1)
  ]))]))
}
export default { render: render }